import { useState, useEffect } from "react";
import InsightsServices from "../../services/Insights.services";

function useRunIndividual(data, language) {
    const [isLoading, setIsLoading] = useState(false);
    const [rerun, setRerun] = useState(false);
    const [isError, setIsError] = useState(false);
    const [details, setDetails] = useState("");

    useEffect(() => {
        if ((data && language) || rerun) {
            setIsError(false);
            setIsLoading(true);
            InsightsServices.runIndividual(data, language).then((resp) => {
                setRerun(false);
                setIsLoading(false);
                if (resp === "error") {
                    setIsError(true);
                    setDetails("");
                    return;
                }
                if (resp) {
                    setDetails(resp.data[0]);
                }
            });
        }
    }, [data, language, rerun]);

    return {
        isLoading,
        details,
        isError,
        setRerun
    };
}

export default useRunIndividual;
